import { render } from "./error-modal.vue?vue&type=template&id=6f6dbf67&ts=true"
import script from "./error-modal.ts?vue&type=script&lang=ts&external"
export * from "./error-modal.ts?vue&type=script&lang=ts&external"

import "./error-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__